/**
 * react-router keeps the index of the current history entry in `history.state.idx`. 0 means the app
 * was opened right on this screen (a startapp link replaces the root entry), so `navigate(-1)` has
 * nowhere to go and the back button must go to a parent screen instead.
 */
export function isFirstHistoryEntry(): boolean {
  const state = window.history.state as { idx?: unknown } | null;
  return state?.idx === 0;
}

/** The parent of a sub-page path: /me/charts/c1/edit → /me/charts/c1, /me/charts → /me, /settings/account → /settings. */
export function parentPath(pathname: string): string {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length <= 1) return '/me';
  return '/' + parts.slice(0, -1).join('/');
}
